// @ts-expect-error
// eslint-disable-next-line no-unused-vars
import React from "react";
import { Script } from "gatsby";
import { algoliasearch } from "algoliasearch";
import { InstantSearch } from "react-instantsearch";

export const wrapPageElement = ({ element }) => {
    const searchClient = algoliasearch("0FHW9168YY", "53cb6079043ea552e83befd92a7509dc");

    return (
        <>
            <InstantSearch searchClient={searchClient} indexName="blog_posts">
                {element}
            </InstantSearch>
            {element.props.location.origin === "https://www.assertiveyield.com" ? (
                <>
                    <Script
                        async
                        defer
                        strategy="idle"
                        src="https://www.googletagmanager.com/gtag/js?id=UA-114303038-2"
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        dangerouslySetInnerHTML={{
                            __html: `
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', 'UA-114303038-2');
                            `,
                        }}
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        dangerouslySetInnerHTML={{
                            __html: `
                                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                })(window,document,'script','dataLayer','GTM-PMGC9G3');
                            `,
                        }}
                    />
                    <Script
                        async
                        defer
                        strategy="idle"
                        dangerouslySetInnerHTML={{
                            __html: `
                                !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
                                analytics.load("dG9z830omica4NchwuttNAnnYtNcuMGf");
                                analytics.page();
                                }}();
                            `,
                        }}
                    />
                    <Script
                        type="application/javascript"
                        src="https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js"
                    />
                    <Script
                        id="usercentrics-cmp"
                        src="https://web.cmp.usercentrics.eu/ui/loader.js"
                        data-settings-id="gXJgofDOSBgGLu"
                        async
                    />
                </>
            ) : null}
            <link rel="preconnect" href="//privacy-proxy.usercentrics.eu" />
            <link rel="preload" href="//privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js" as="script" />
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/docsearch.js/2/docsearch.min.css" />
            <link
                rel="stylesheet"
                href="https://cdn.jsdelivr.net/npm/instantsearch.css@8.5.1/themes/satellite-min.css"
                integrity="sha256-woeV7a4SRDsjDc395qjBJ4+ZhDdFn8AqswN1rlTO64E="
                crossorigin="anonymous"
            />

            <Script async defer strategy="idle" src="https://cdn.jsdelivr.net/docsearch.js/2/docsearch.min.js" />
        </>
    );
};
